import http from '../utils/http';

export default class HealthService {
  static async config() {
    const { data } = await http.get('/health');
    return data;
  }
}
